<template>
  <div :style="{ marginTop: firstPage ? '0' : '60px' }">
    <header :style="headerStyle">
      <div class="container clearfix">
        <RouterLink v-if="!scrolled && firstPage" to="/" id="logo">
          <img :src="logoSrc || whiteLogoSrc" alt="Logo" />
        </RouterLink>

        <RouterLink v-else to="/" id="logo">
          <img :src="logoSrc || blueLogoSrc" alt="Logo" />
        </RouterLink>

        <div v-if="!scrolled && firstPage" id="menu-toggle" @click="toggleMenu">
          <span style="background-color: white;"></span>
          <span style="background-color: white;"></span>
          <span style="background-color: white;"></span>
          <span style="background-color: white;"></span>
        </div>

        <div v-else id="menu-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav class="main-navigation" :class="{ 'show-menu': isMenuVisible }">
          <div class="menu-main-navigation-ro-container">
            <ul id="menu-main-navigation-ro" class="menu">
              <li v-for="menuItem in menuItems" :key="menuItem.id || menuItem.order">
                <RouterLink :to="menuItem.link" class="no-underline"
                  :class="{ 'white-text': !scrolled && firstPage }">
                  {{ menuItem.title }}
                </RouterLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>

    <div v-if="isMenuVisible" class="white-menu">
      <img :src="logoSrc || blueLogoSrc" alt="Logo" class="center-logo" />
      <div class="close-button" @click="toggleMenu">&times;</div>

      <ul id="menu-main-navigation-ro" class="menu center-menu text-left" style="align-items: left;">
        <li v-for="menuItem in menuItems" :key="menuItem.id || menuItem.order">
          <RouterLink :to="menuItem.link" class="no-underline" @click="toggleMenu">
            {{ menuItem.title }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    firstPage: Boolean
  },
  data() {
    return {
      headerData: {},
      blueLogoSrc: require('@/assets/Ingka_investments_wordmark_Blue_CMYK.png'),
      whiteLogoSrc: require('@/assets/Ingka_investments_wordmark_White_CMYK.png'),
      logoSrc: '', // logo from the API (absolute Azure Blob URL), falls back to bundled assets
      lastScroll: 0,
      scrolled: false,
      isMenuVisible: false,
      apiUrl: process.env.VUE_APP_WEBSITE_HOSTNAME,
    };
  },
  computed: {
    menuItems() {
      const items = this.headerData.menu_items_en;
      if (!Array.isArray(items)) return [];
      // Respect active flag, sort ascending by order.
      return items
        .filter(item => item.active)
        .slice()
        .sort((a, b) => a.order - b.order);
    },
    headerStyle() {
      return {
        backgroundColor: this.isMenuVisible ? 'white' : (this.scrolled ? 'white' : 'transparent'),
        borderBottom: this.firstPage && !this.scrolled ? 'none' : '1px solid #E1E5E8'
      };
    },
  },
  methods: {
    handleScroll() {
      const currentScroll = window.pageYOffset;
      this.lastScroll = currentScroll <= 0 ? 0 : currentScroll;
      this.scrolled = window.scrollY > 50;
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);

    const token = process.env.VUE_APP_WEBSITE_TOKEN;
    const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

    axios.get(`${API_URL}/api/menu-content`, {
      headers: {
        'Authorization': `Token ${token}`,
      },
    })
      .then(response => {
        this.headerData = response.data || { logo: [], menu_items_en: [] };
        // logo is an array of logo objects; use the first one if present.
        if (Array.isArray(this.headerData.logo) && this.headerData.logo.length > 0) {
          this.logoSrc = this.headerData.logo[0].logo || '';
        }
      })
      .catch(error => {
        console.error('Error fetching Header data:', error);
      });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};

</script>

<style>
@import '@/css/header.css';

.no-underline {
  text-decoration: none;
}

.white-text {
  color: white;
}

.white-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
}

.center-logo {
  position: absolute;
  top: 0;
  margin-left: 2rem;
  height: 60px;
  margin: 0;
}

.center-menu {
  margin-left: 2rem;
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.center-menu li {
  margin-bottom: 5px;
  text-align: left;
}

.center-menu li a {
  color: #6E8496;
  text-align: center;
}

.center-menu li a :hover {
  color: #0058A3;
}

.show-menu {
  display: block;
  position: absolute;
  top: 60px;
  right: 0;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
}

.close-button {
  position: absolute;
  top: 0;
  right: 2rem;
  cursor: pointer;
  font-size: 42px;
  color: #0058A3;
  background-color: transparent;
  z-index: 1002;
}

ul {
  list-style-type: none;
  left: 0;
}
</style>
